<template lang="pug">
  article.product.min-h-screen.lg--mt-140
    template(v-if="doc")
      main-el.lg-flex.flex-wrap.items-start.flex-row-reverse.relative.px-15.md-px-180.lg-px-24
        //- right column
        section.w-full.lg-w-1x2.px-10.lg-min-h-screen.flex.items-center.justify-center.lg-sticky.top-0.right-0
          .w-full.lg-max-w-400.text-center.pb-82.lg-pt-82
            //- title/vendor
            header.text-18.md-text-24.leading-xl.flex.flex-col
              h1 {{ titleNoVendor }}
              .order-first {{ doc.vendor }}
            //- price
            .mt-15.text-15.md-text-17.md-mt-8.leading-2xl(v-if="variant")
              template(v-if="variantTitle") {{ variantTitle }}
              template(v-if="!priceHidden")
                br
                product-price.mt-2.inline-block(:amount="variant.priceV2.amount", :isSoldOut="variant.availableForSale === false")
            //- (btns lnd: add, options)
            product-actions.mt-40(v-if="winIs('lg')", :product="doc", :active="variant", @variant="variant = $event", :enquiry="enquiry", @enquire="enquire = true", @changeColor="$event => $router.replace({params: {handle: $event}})", @viewSizing="sizeGuideModal = true", @viewShipping="shippingModal = true")

        //- left column
        section.w-full.lg-w-1x2.lg-px-10.overflow-x-hidden.text-15.md-text-17.lg-pt-140
          //- first / variant img
          figure.relative.pb-ar-2x3.hover-invisible--parent.bg-gray-200(v-if="firstImg")
            resp-img-shopify(:bg="true", :image="firstImg")
            button.hidden.md-block.absolute.overlay.transition-opacity.duration-200.hover-invisible--child(aria-label="View Image Fullscreen", @click="view(firstImg.originalSrc)")
              full-screen-icon.absolute.bottom-10.right-10

          //- (actions mbl)
          product-actions.my-100.w-grid-20.-ml-20.px-15.sm-w-full.sm-max-w-300.sm-mx-auto(v-if="!winIs('lg')", :product="doc", :active="variant", @variant="variant = $event", :enquiry="enquiry", @enquire="enquire = true", @viewSizing="sizeGuideModal = true", @viewShipping="shippingModal = true")
          //- description
          .my-100.lg-my-200
            .product__descrip.children-mt-em.bulleted-lists(ref="descrip", v-html="description", :class="{'product__descrip--less-off': !more}")
            //- button.mt-em.text-13.btn-theme-text(@click="more = true", v-show="more === false") Read More

          //- images...
          template(v-for="(image, i) in doc.images.edges.slice(1)")
            figure.my-100.lg-my-200
              .relative.pb-ar-2x3.hover-invisible--parent.bg-gray-200
                resp-img-shopify(:bg="true", :image="image.node")
                button.hidden.md-block.absolute.overlay.transition-opacity.duration-200.hover-invisible--child(aria-label="View Image Fullscreen", @click="view(image.node.originalSrc)")
                  full-screen-icon.absolute.bottom-10.right-10
            //- caption (shopify image alt text)
            p.my-100.lg-my-200(v-html="image.node.altText", v-if="image.node.altText && image.node.altText.length")

      //- related
      footer
        h4.text-center.text-15.md-text-17 Recommended
        //- collection links
        ul.mt-40.flex.flex-wrap.justify-center.whitespace-no-wrap
          li.my-3.mx-5.md-mx-12(v-for="edge in doc.collections.edges")
            router-link(:to="{name: 'products_collection', params: {collection: edge.node.handle}}")
              link-with-arrow All {{edge.node.title}}
        //- related products
        related-products(:handles="relatedProducts")

      //- viewer
      viewer(v-if="viewerAt > -1", :viewerAt="viewerAt", :images="slides", @close="viewerAt = -1")
      //- enquire-overlay
      transition(name="fade", @after-enter="lockScroll(true)", @before-leave="lockScroll(false)")
        enquire.fixed.lg-fixed(v-if="enquire", :details="enquiry", @close="enquire = false")
      //- size guide modal
      transition(name="overlaymenu", @after-enter="lockScroll(true)", @before-leave="lockScroll(false)")
        product-size-guide-modal(v-if="sizeGuideModal", :product="doc", @close="sizeGuideModal = false")

      //- size guide modal
      transition(name="overlaymenu", @after-enter="lockScroll(true)", @before-leave="lockScroll(false)")
        shipping-modal(v-if="shippingModal", :product="doc", @close="shippingModal = false")

    //- not found !
    template(v-else-if="doc === null")
      not-found-in-shop.pt-100.lg-pt-120 Item Not Found
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { variantId as vId } from '@/utils'
import ProductActions from '@/components/Shop/ProductActions'
import FullScreenIcon from '@/components/Icons/FullScreenIcon'
import RelatedProducts from '@/components/Shop/RelatedProducts'
import ProductPrice from '@/components/Shop/ProductPrice'
import NotFoundInShop from '@/components/Shop/NotFoundInShop'
import ProductSizeGuideModal from '@/components/Shop/ProductSizeGuideModal'
import ShippingModal from '@/components/Shop/ShippingModal'
import RespImgShopify from '@/components/Shop/RespImgShopify'
import Viewer from '@/components/Carousel/Viewer'
import get from 'lodash/get'
export default {
  name: 'Product',
  props: ['handle'],
  data () {
    return {
      doc: undefined,
      variant: null,
      viewerAt: -1,
      enquire: false,
      more: null, // set to false if hasMore
      sizeGuideModal: false,
      shippingModal: false
    }
  },
  computed: {
    ...mapGetters({ price: 'shop/price', nav: 'shop/nav', winIs: 'winIs' }),
    firstImg () {
      return this.variantImage || get(this.doc, 'images.edges[0].node')
    },
    variantTitle () {
      if (!this.variant) return null
      const color = this.variant.selectedOptions.find(opt => ['color', 'colour'].includes(opt.name.toLowerCase()))
      let ttl = (color && color.value) || this.variant.title
      ttl = ttl === 'Default Title' ? null : ttl
      return ttl
    },
    variantImage () {
      return get(this.variant, 'image')
    },
    titleNoVendor () {
      return this.doc.title.replace(this.doc.vendor + ' ', '')
    },
    slides () {
      // caption
      let variantTitle = ''
      if (this.variantTitle) { variantTitle = `<br/>${this.variantTitle}` }

      let caption = `${this.doc.vendor}<br>${this.titleNoVendor}${variantTitle}`
      // ...add price?
      caption += !this.priceHidden ? `<br>${this.price(this.variant.priceV2.amount)}` : ''
      // slides...
      return this.doc && this.doc.images.edges.map(edge => ({
        url: edge.node.originalSrc,
        alt: edge.node.altText,
        width: 1,
        height: 1,
        _carousel_type: this.winIs('md') ? 'overflow' : 'default',
        caption: `<p>${caption}</p>`
      }))
    },
    metafields () {
      const meta = get(this.doc, 'metafields.edges') || []
      return meta && meta.map(edge => edge.node)
    },
    priceHidden () {
      return this.metafields.find(meta => meta.key === 'price_hidden')
    },
    enquiry () {
      let enquiry
      const isEnquireOnly = this.metafields.find(meta => meta.key === 'enquiry_only')
      if (isEnquireOnly && this.doc) {
        const img = this.firstImg || {}
        const vT = this.variantTitle
        const title = `${this.doc.vendor}<br>${this.titleNoVendor}${vT ? '<br><span class="text-15 md-text-17">' + vT + '</span>' : ''}`
        // format
        enquiry = {
          type: 'product',
          ref: `${this.doc.title}${vT ? ' – ' + vT : ''}`,
          postId: null, // this.docWP.id,
          thumb: img.transformedSrc,
          caption: title,
          image: { url: img.transformedSrc, alt: img.altText }
        }
      }
      return enquiry
    },
    relatedProducts () {
      let vals = get(this.doc, 'metafields.edges') || []
      vals = vals.find(edge => edge.node.key === 'related_products')
      vals = get(vals, 'node.value')
      return vals && vals.split('|')
    },
    description () {
      return this.doc && this.doc.descriptionHtml.replaceAll(/<meta[^>]+>/gm, '') // strip <meta> tags...
    }
  },
  methods: {
    ...mapMutations(['lockScroll']),
    async get () {
      try {
        this.doc = await this.$store.dispatch('shop/getProduct', { handle: this.handle })
        this.setMore()
      } catch (e) {
        console.error(e)
      }
    },
    view (src) {
      this.viewerAt = this.slides.findIndex(slide => slide.url === src)
    },
    setMore () {
      this.$nextTick(() => {
        if (!this.$refs.descrip) return
        const els = Array.prototype.slice.call(this.$refs.descrip.children) // Array.prototype.slice.call(
        const hiddenChilds = els.filter(el => el && el.nodeName === 'P' && getComputedStyle(el).getPropertyValue('display') === 'none')
        this.more = !hiddenChilds.length ? null : false
      })
    }
  },
  watch: {
    variant (vrnt) {
      const id = vrnt && vId(vrnt.id)
      return id && this.$route.query.variant !== id && this.$router.replace({ query: { variant: id } })
    }
  },
  created () {
    this.get()
  },
  metaInfo () {
    if (!this.doc) return
    const vT = this.variantTitle !== 'Default Title' ? this.variantTitle : null
    const title = this.doc.title + `${vT ? ' - ' + vT : ''}`
    const img = get(this.doc, 'images.edges[0].node.meta')
    const meta = this.$store.getters.meta({ title, img, descrip: this.doc.description })
    meta.push({ name: 'robots', content: 'noindex,nofollow' })
    return {
      title: title,
      meta: meta,
      links: [
        { rel: 'canonical', href: process.env.VUE_APP_CANONICAL_DOMAIN + '/products/' + this.doc.handle }
      ]
    }
  },
  components: { ProductActions, Viewer, FullScreenIcon, RelatedProducts, ProductPrice, NotFoundInShop, ProductSizeGuideModal, ShippingModal, RespImgShopify }
}
</script>

<style>
</style>
